export default __webpack_public_path__ + "static/media/204.fe938ada.jpg";